import Navigation from "./navigation/Navigation";
import "./Header.css";
import { Link } from "react-router-dom";
import LngSwitch from "./lngSwitch/LngSwitch";
import ShowNavigationBtn from "./showNavigationBtn/ShowNavigationBtn";
import { useState } from "react";
import CallToActionButton from "../../components/callToActionBlock/callToActionButton/CallToActionButton";
import { useMediaQuery } from "@mui/material";
import logoHoriz from "../../assets/brand/logo-horiz.png";

export default function Header() {
  const [showNavigation, setShowNavigation] = useState(false);
  const smallScreen = useMediaQuery("(max-width: 1240px)");

  const callToActionButtonStyle = {
    height: "46px",
    minWidth: "152px",
    fontSize: "14px",
  };

  return (
    <header className="header">
      <ShowNavigationBtn
        showNavigation={showNavigation}
        setShowNavigation={setShowNavigation}
      />

      <Link className="header__brand" to="/" aria-label="ACTIVE Generation">
        <img className="header__brand-logo" src={logoHoriz} alt="ACTIVE Generation" />
      </Link>

      {!smallScreen ? (
        <div className="header__navigation">
          <Navigation
            isActive={showNavigation}
            setShowNavigation={setShowNavigation}
          />
          <CallToActionButton
            buttonStyles={callToActionButtonStyle}
            attachmentBlock={"HeaderBlock"}
          />
        </div>
      ) : (
        <Navigation
          isActive={showNavigation}
          setShowNavigation={setShowNavigation}
        />
      )}

      <div className="header_buttons">
        <LngSwitch />
      </div>
    </header>
  );
}
